/** Regex pattern's to match environment types. */
const searches = {
  local: /^LOCAL(_[A-Z0-9]+)?/,
  prod: /^([A-Z0-9]+_)?PROD$/
};

export type EnvironmentInfo = {
  /** Whether the application is running on a local machine while being developed. */
  isLocal: boolean;
  /** Whether the environment is pointing to PROD APIs for getting/modifying data. */
  isProd: boolean;
};

export function getEnvironmentInfo(env: string): EnvironmentInfo {
  return {
    isLocal: searches.local.test(env),
    isProd: searches.prod.test(env)
  };
}
